export function gameSceneLayout(k) {
    // --- Render Map  ---
    function renderMap(map, tileset, zIndex = 0, ajustX = 0, ajustY = 0, scaleNb= 1, tileSize=64) {
        map.forEach((row, rowIndex) => {
            row.forEach((frame, colIndex) => {
                k.add([
                    k.sprite(tileset, { frame }),
                    k.pos((colIndex * tileSize) + ajustX, (rowIndex * tileSize) + ajustY),
                    k.z(zIndex),
                    k.scale(scaleNb),
                ]);
            });
        });
    }

    function generateLayoutDecoration(x, y, asset, zIndex) {
        const decoration = k.add([
            k.sprite(asset),
            k.pos(x, y),
            k.z(zIndex),
            k.anchor('bot'),
            "decoration",
        ]);
        decoration.play("idle");
    }

    // --- Level Generation ---
    const decorations = k.addLevel(
        [
            "............111...",
            ".2................",
            "2...............2.",
            "..1111111111111..2",
            ".11............11.",
            "1...74....3......1",
            "................76",
            "..5...............",
        ],
        {
            tileWidth: 64, tileHeight: 64, pos: k.vec2(-64, 0),
            tiles: {
                "1": () => [ k.sprite("foam", { anim: "idle" }), k.scale(1), k.z(0) ],
                "2": () => [ k.sprite("tileShadow"), k.z(2), k.opacity(1), k.scale(1) ],
                "3": () => [ k.sprite("waterRock1", { anim: "idle" }), k.z(2), k.opacity(1), k.scale(1) ],
                "4": () => [ k.sprite("waterRock2", { anim: "idle" }), k.z(2), k.opacity(1), k.scale(1) ],
                "5": () => [ k.sprite("waterRock3", { anim: "idle" }), k.z(2), k.opacity(1), k.scale(1), k.pos(-25,-20) ],
                "6": () => [ k.sprite("waterRock4", { anim: "idle" }), k.z(2), k.opacity(1), k.scale(1), k.pos(0,20) ],
                "7": () => [ k.sprite("waterRock1", { anim: "idle" }), k.z(2), k.opacity(1), k.scale(1), k.pos(40,-10) ],
            }
        }
    );

    const floor0 = k.addLevel(
        [
            "..................",
            "............789...",
        ],
        {
            tileWidth: 64, tileHeight: 64, pos: k.vec2(0, 3),
            tiles: {
                ".": () => [k.sprite("Tilemap_color4", { frame: 4 })],
                "1": () => [k.sprite("Tilemap_color4", { frame: 18 })],
                "2": () => [k.sprite("Tilemap_color4", { frame: 19 })],
                "3": () => [k.sprite("Tilemap_color4", { frame: 20 })],
                "4": () => [k.sprite("Tilemap_color4", { frame: 9 })],
                "5": () => [k.sprite("Tilemap_color4", { frame: 10 })],
                "6": () => [k.sprite("Tilemap_color4", { frame: 11 })],
                "7": () => [k.sprite("Tilemap_color4", { frame: 0 })],
                "8": () => [k.sprite("Tilemap_color4", { frame: 1 })],
                "9": () => [k.sprite("Tilemap_color4", { frame: 2 })],
            }
        }
    );

    const floor1 = k.addLevel(
        [
            "79..............78",
            "558e..........r855",
            "555588888888885555",
            "555222222222222555",
            "523::::::::::::125",
            "3:!............;:1",
            "!................;",
            "..................",
        ],
        {
            tileWidth: 64, tileHeight: 64, pos: k.vec2(0, 0),
            tiles: {
                ".": () => [k.sprite("Tilemap_color1", { frame: 4 }),k.z(1)],
                "1": () => [k.sprite("Tilemap_color1", { frame: 23 }),k.z(1)],
                "2": () => [k.sprite("Tilemap_color1", { frame: 24 }),k.z(1)],
                "3": () => [k.sprite("Tilemap_color1", { frame: 25 }),k.z(1)],
                "4": () => [k.sprite("Tilemap_color1", { frame: 14 }),k.z(1)],
                "5": () => [k.sprite("Tilemap_color1", { frame: 15 }),k.z(1)],
                "6": () => [k.sprite("Tilemap_color1", { frame: 16 }),k.z(1)],
                "7": () => [k.sprite("Tilemap_color1", { frame: 5 }),k.z(1)],
                "8": () => [k.sprite("Tilemap_color1", { frame: 6 }),k.z(1)],
                "9": () => [k.sprite("Tilemap_color1", { frame: 7 }),k.z(1)],
                "i": () => [k.sprite("Tilemap_color1", { frame: 32 }),k.z(1)],
                "o": () => [k.sprite("Tilemap_color1", { frame: 33 }),k.z(1)],
                "p": () => [k.sprite("Tilemap_color1", { frame: 34 }),k.z(1)],
                "k": () => [k.sprite("Tilemap_color1", { frame: 41 }),k.z(1)],
                "l": () => [k.sprite("Tilemap_color1", { frame: 42 }),k.z(1)],
                "m": () => [k.sprite("Tilemap_color1", { frame: 43 }),k.z(1)],
                ";": () => [k.sprite("Tilemap_color1", { frame: 50 }),k.z(1)],
                ":": () => [k.sprite("Tilemap_color1", { frame: 51 }),k.z(1)],
                "!": () => [k.sprite("Tilemap_color1", { frame: 52 }),k.z(1)],
                "e": () => [k.sprite("Tilemap_color1", { frame: 39 }),k.z(1)],
                "r": () => [k.sprite("Tilemap_color1", { frame: 36 }),k.z(1)],
            }
        }
    );

    const floor2 = k.addLevel(
        [
            "..................",
            "9................7",
            "3...............i5",
            "m...............k1",
            ".................k",
        ],
        {
            tileWidth: 64, tileHeight: 64, pos: k.vec2(0, 0),
            tiles: {
                ".": () => [k.sprite("Tilemap_color3", { frame: 4 }), k.z(3)],
                "0": () => [k.sprite("Tilemap_color3", { frame: 7 }), k.z(3)],
                "1": () => [k.sprite("Tilemap_color3", { frame: 23 }), k.z(3)],
                "2": () => [k.sprite("Tilemap_color3", { frame: 24 }), k.z(3)],
                "3": () => [k.sprite("Tilemap_color3", { frame: 25 }), k.z(3)],
                "4": () => [k.sprite("Tilemap_color3", { frame: 14 }), k.z(3)],
                "5": () => [k.sprite("Tilemap_color3", { frame: 15 }), k.z(3)],
                "6": () => [k.sprite("Tilemap_color3", { frame: 16 }), k.z(3)],
                "7": () => [k.sprite("Tilemap_color3", { frame: 5 }), k.z(3)],
                "8": () => [k.sprite("Tilemap_color3", { frame: 6 }), k.z(3)],
                "9": () => [k.sprite("Tilemap_color3", { frame: 7 }), k.z(3)],
                "i": () => [k.sprite("Tilemap_color3", { frame: 32 }), k.z(3)],
                "o": () => [k.sprite("Tilemap_color3", { frame: 33 }), k.z(3)],
                "p": () => [k.sprite("Tilemap_color3", { frame: 34 }), k.z(3)],
                "k": () => [k.sprite("Tilemap_color3", { frame: 41 }), k.z(3)],
                "l": () => [k.sprite("Tilemap_color3", { frame: 42 }), k.z(3)],
                "m": () => [k.sprite("Tilemap_color3", { frame: 43 }), k.z(3)],
                ";": () => [k.sprite("Tilemap_color3", { frame: 50 }), k.z(3)],
                ":": () => [k.sprite("Tilemap_color3", { frame: 51 }), k.z(3)],
                "!": () => [k.sprite("Tilemap_color3", { frame: 52 }), k.z(3)],
            }
        }
    );

    const banner = [
        [ 0,  1,  3,  3,  3,  3,  5,  6],
        [ 7,  8, 10, 10, 10, 10, 12, 13],
        [42, 43, 45, 45, 45, 45, 47, 48],
    ];

    renderMap(banner, "banner", 30, 64, -50, 1, 64);

    generateLayoutDecoration(64, 64+20, "Tree4", 13);
    generateLayoutDecoration(64*2, 64*2+50, "Tree4", 16);
    generateLayoutDecoration(64*2+50, 64*4, "Tree1", 19);
    generateLayoutDecoration(30, 64*3, "Tree3", 18);
    generateLayoutDecoration(64+20, 310, "Tree2", 19);
    generateLayoutDecoration(20, 64*5, "bushe2", 16);
    generateLayoutDecoration(20, 64*6, "bushe3", 16);
    generateLayoutDecoration(64*17, 95, "Tree1", 16);
    generateLayoutDecoration(64*16, 150, "Tree3", 16);
    generateLayoutDecoration(64*16+50, 64*3, "bushe3", 12);
    generateLayoutDecoration(64*15+20, 200, "Tree1", 19);
    generateLayoutDecoration(64*17+40, 64*3+50, "Tree2", 19);
    generateLayoutDecoration(64*15, 270, "Tree4", 20);
    generateLayoutDecoration(64*16, 320, "Tree3", 21);
    generateLayoutDecoration(64*17+40, 64*6+20, "bushe1", 21);

    k.add([
        k.sprite("stump1"),
        k.pos(64*13, 20),
        k.z(13),
        k.anchor('center')
    ])
}